module.exports = __webpack_public_path__ + "img/swiper_1.d18ef39f.jpg";